import { errorSourceLabels, type SagaAuditLogDto } from '@/dtos/ErrorHandlingSaga'
import { Badge, Box, Flex, Text } from '@chakra-ui/react'

const formatDate = (value?: string) => (value ? new Date(value).toLocaleString('cs-CZ') : '')

/**
 * Compact audit-attempt list for a transition's hover tooltip. Rendered in received order — the server already orders
 * steps by CompletedAt — so no client-side sort.
 */
export const AuditStepList = ({ steps }: { steps: SagaAuditLogDto[] }) => (
  <Box maxW="340px" maxH="280px" overflowY="auto" px={2} py={1}>
    {steps.map((s, i) => (
      <Box key={s.id ?? i} py={1.5} borderTopWidth={i ? '1px' : 0} borderColor="gray.100">
        <Flex align="center" gap={2} mb={0.5}>
          <Badge colorScheme={s.success ? 'green' : 'red'}>{s.success ? 'OK' : 'CHYBA'}</Badge>
          <Text fontSize="xs" fontWeight="semibold">{s.messageType}</Text>
        </Flex>
        <Text fontSize="xs" color="gray.500">{formatDate(s.completedAt)}</Text>
        {s.errorSource != null && (
          <Text fontSize="xs" color="gray.500">Zdroj: {errorSourceLabels[s.errorSource]}</Text>
        )}
        {(s.error || s.reason) && (
          <Text fontSize="xs" color="red.600" mt={0.5} noOfLines={4}>{s.error ?? s.reason}</Text>
        )}
      </Box>
    ))}
  </Box>
)
